import React, { createContext, useState, useEffect, ReactNode } from 'react';

interface UserInfo {
    fullName?: string;
    photo_url?: string;
    email?: string;
    role?: string;
    [key: string]: any;
}

interface AppContextType {
    adminAccessToken: string;
    userInfo: UserInfo;
    updateUserInfo: (newUserInfo: UserInfo) => void;
}

const AppContext = createContext<AppContextType>({
    adminAccessToken: '',
    userInfo: {},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    updateUserInfo: () => { },
});

interface AppContextProviderProps {
    children: ReactNode;
}

const AppContextProvider: React.FC<AppContextProviderProps> = ({ children }) => {
    const [adminAccessToken, setAdminAccessToken] = useState<string>('');
    const [userInfo, setUserInfo] = useState<UserInfo>({});

    // Initialize from localStorage
    useEffect(() => {
        const token = localStorage.getItem('adminAccessToken');
        const user = localStorage.getItem('user');

        setAdminAccessToken(token || '');
        setUserInfo(user ? JSON.parse(user) : {});
    }, []);

    // Listen for profile updates
    useEffect(() => {
        const handleProfileUpdate = () => {
            const user = localStorage.getItem('user');
            if (user) {
                const userData = JSON.parse(user);
                setUserInfo(userData);
            }
        };

        window.addEventListener('userProfileUpdated', handleProfileUpdate);

        return () => {
            window.removeEventListener('userProfileUpdated', handleProfileUpdate);
        };
    }, []);

    // Function to update user info
    const updateUserInfo = (newUserInfo: UserInfo) => {
        setUserInfo(newUserInfo);
        localStorage.setItem('user', JSON.stringify(newUserInfo));
    };

    return (
        <AppContext.Provider value={{ adminAccessToken, userInfo, updateUserInfo }}>
            {children}
        </AppContext.Provider>
    );
};

export { AppContext, AppContextProvider };

